<!--  -->
<template>
  <div class="">
    <!--    内容-->
    <div class="main1">
      <div class="notice">
        <h2>义务教育招生报名系统须知</h2>
        <p>1.系统默认每名学生只能在1所学校登记信息申报。</p>
        <p>
          2.网上报名的先后顺序与招生录取无关，请家长避开网络高峰拥堵时段，提前准备好相关材料，确保在规定时间内填报完毕，超过规定时间后系统将关闭填报功能。
        </p>
        <p>
          3.按照流程和要求如实填写相关信息。标红色星号为必须填写和上传项目。
        </p>
        <p>
          4.上传照片要求:证件原件拍照，照片完整、平整、无杂乱背景，多余边缘进行裁剪后上传。
        </p>
        <p>
          5.未点击提交可以自行修改或删除信息重新填写，请仔细核对填写信息及上传资料后再点击确认提交信息。如提交成功，则无法修改信息。
        </p>
        <p>6.审核结果将在本平台告知，届时请登录查看。</p>
        <p class="cu">
          城区公办中小学学区划分（如学区范围描述与学区图不符，请以学区图为准）
        </p>
        <p class="cu">
          ①第一实验小学学区范围（招生咨询电话：4222635、18543512729）
        </p>
        <p>
          东－松江路、民安路,南－梅河、辉发河河堤，西－福民大桥，北－沈吉铁路线。所辖新华街道金华社区（4委、5委、12委、13委）、新华街道松江社区（1委、2委、3委、14委、15委）
        </p>
        <p class="cu">②第二实验小学学区范围（招生咨询电话：4225385）</p>
        <p>
          东－建国路，南－辉发河河堤，西－松江路、民安路，北－沈吉铁路线。所辖新华街道建国社区18委-21委、解放街道22委-30委
        </p>
        <p class="cu">
          ③第三实验小学学区范围（招生咨询电话：4231166、15943573023、13630715071）
        </p>
        <p>
          东－民悦街（铁二街），南－昆明路至北环西路（含芳园小区），西北－北环路
        </p>
        <p class="cu">
          ④第四实验小学学区范围（招生咨询电话：4668800、13394457567）
        </p>
        <p>东－建国路,南－沈吉铁路线，西－民悦街（铁二街），北－北环路</p>
        <p class="cu">⑤第五实验小学学区范围（招生咨询电话：5094203）</p>
        <p>东－建国路，南－南环路，西－朝阳路，北－辉发河河堤</p>
        <p class="cu">⑥解放街中心校学区范围（招生咨询电话：4226171）</p>
        <p>
          东－季家村莲河桥交界，南－辉发河河堤，西－建国路，北－东丰交界。所辖解放街道园林社区、电厂社区、新城村、季家村
        </p>
        <p class="cu">
          ⑦外国语学校小学部学区范围（招生咨询电话：4377156,4377180）
        </p>
        <p>梅河河堤以南、大柳河河堤以西福民街道所辖区域</p>
        <p class="cu">⑧育红小学学区范围（招生咨询电话：4354558）</p>
        <p>
          东－沈吉铁路线，南－梅河河堤，西－东丰交界，北－昆明路，所辖新华街道爱民社区（6委、7委、8委、9委、16委、17委），新华街道同意村，和平街道全胜村，黑山头镇丰收村
        </p>
        <p class="cu">
          ⑨育秀小学学区范围（招生咨询电话：6963007、18644890212）
        </p>
        <p>东－朝阳路，南－南环西路，西－西环路，北－滨河南街</p>
        <p class="cu">
          ⑩朝鲜族实验小学学区范围（招生咨询电话：4899900、15844547922）
        </p>
        <p>除招收本民族学生外，2024年秋季可招收非本民族学生，不受学区限制</p>
        <p class="cu">
          ⑪梅河新区博雅实验学校小学部学区范围（招生咨询电话：18104447199）
        </p>
        <p>北－南环西路、东－松江路（啤酒小镇区域）</p>
        <p class="cu">⑫光明小学学区范围</p>
        <p>东－长江路，南－南环路，西－建国路，北－辉发河河堤</p>
        <p class="cu">
          ⑬实验中学学区范围（招生咨询电话：4210565、15843503345）
        </p>
        <p>
          东－季家村莲河桥交界，南－辉发河河堤，西－松江路、民安路，北－沈吉铁路线、东丰交界；解放街道全域，新华街道建国社区18委-21委
        </p>
        <p class="cu">
          ⑭第二实验中学学区范围（招生咨询电话：4312296、18743588698）
        </p>
        <p>
          东－建国路，南－沈吉铁路线，西北至东丰交界，所辖和平街道区域、新华街道爱民社区（6委、7委、8委、9委、16委、17委）
        </p>
        <p class="cu">
          ⑮第三中学学区范围（招生咨询电话：13943507010、13604355607）
        </p>
        <p>东－建国路，南－南环路，西－朝阳路，北－辉发河河堤</p>
        <p class="cu">
          ⑯外国语学校初中部学区范围（招生咨询电话：4375318、4375992）
        </p>
        <p>
          东－松江路、民安路，南－辉发河、大柳河，北－沈吉铁路线，福民街道、新华街道金华社区（4委、5委、12委、13委）、新华街道松江社区（1委、2委、3委、14委、15委），及原六中所属黑山头镇所辖区域
        </p>
        <p class="cu">⑰育才中学学区范围（招生咨询电话：6069668、6069207）</p>
        <p>东－朝阳路，南－南环西路，西－西环路，北－滨河南街</p>
        <p class="cu">
          ⑱朝鲜族中学学区范围（招生咨询电话：4237415、13944568671）
        </p>
        <p>除招收本民族学生外，2024年秋季继续招收非本民族学生，不受学区限制</p>
        <p class="cu">
          ⑲梅河新区博雅实验学校初中部学区范围（招生咨询电话：18743552653）
        </p>
        <p>北－南环西路、南－李炉乡所辖区域（啤酒小镇区域、李炉乡所辖区域）</p>
        <p class="cu">⑳光明中学学区范围</p>
        <p>东－长江路，南－南环路，西－建国路，北－辉发河河堤</p>

        <br />
        <br />
        <!-- <el-checkbox v-model="checked">我已认真阅读并知晓以上内容</el-checkbox> -->
        <div class="div">
          <van-checkbox v-model="checked" shape="square"
            >我已认真阅读并知晓以上内容</van-checkbox
          >
        </div>

        <span v-show="show" class="agree" @click="agree">同意并开始</span>
        <span v-show="!show" class="agree">同意并开始（{{ count }}）</span>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      year: "",
      checked: false,
      timer: null,
      count: null,
      show: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 获取年份
    let nowDate = new Date();
    this.year = nowDate.getFullYear();
    this.getSeconds();
  },
  //方法集合
  methods: {
    agree() {
      if (this.checked === false) {
        this.$toast("请认真阅读并知晓须知");
      } else {
        this.$router.push("/login");
      }
    },
    // 按钮读秒定时器
    getSeconds() {
      this.show = false;
      const seconds = 10;
      if (!this.timer) {
        this.count = seconds;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= seconds) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 同意按钮
    handleExamApply() {
      let id = this.$route.params.id;
      let subId = this.$route.params.subId;
      this.$router.push(`/personalCenter/examApplyDetail/${id}/${subId}`);
    },
    // 不同意
    backPage() {
      this.$router.push({
        name: "ExamApply",
      });
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cu {
  font-weight: bold !important;
}
.main1 {
  width: 100%;
  height: auto;
  padding: 1rem 0rem;
  .notice {
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    background: #ffffff;
    background-size: 50%;
    border-radius: 0.4rem;
    margin-bottom: 4rem;
  }
  .notice h2 {
    text-align: center;
    margin-bottom: 1.2rem;
    letter-spacing: 0.2rem;
    font-size: 0.72rem;
  }
}
.notice h2 span {
  display: block;
  width: 2.4rem;
  height: 0.2rem;
  background: rgb(15, 147, 134);
  margin: 0.2rem auto;
  border-radius: 0.2rem;
}
.notice p {
  margin-top: 0.6rem;
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 0.48rem;
  letter-spacing: 0.08rem;
  color: #333333;
  line-height: 0.72rem;
  text-align: justify;
  padding: 0rem 0.8rem;
  margin-block-start: 0em;
  margin-block-end: 0em;
  text-indent: 1.2rem;
}
.agree {
  display: block;
  margin: 2.4rem auto;
  width: 8rem;
  height: 2rem;
  background: rgb(15, 147, 134);
  text-align: center;
  line-height: 2rem;
  color: #fff;
  cursor: pointer;
  margin-bottom: 0rem;
  font-size: 0.72rem;
}
/deep/.van-checkbox__label {
  margin-left: 0.32rem;
  color: #323233;
  line-height: 0.8rem;
  font-size: 0.72rem;
}
.van-checkbox {
  justify-content: center;
}
</style>